import { render, staticRenderFns } from "./DmmLetterTable.vue?vue&type=template&id=ed8462a2"
import script from "./DmmLetterTable.vue?vue&type=script&lang=js"
export * from "./DmmLetterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports